import { FormattedMessage } from "react-intl";

const ReferenceNumberCalculatorText = () => (
  <div className="texts">
    <FormattedMessage id="referenceCalculator" tagName="h1" />
    <FormattedMessage id="infoText" />
  </div>
);

export default ReferenceNumberCalculatorText;
